import React from "react";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";

import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles/";

import store from "store";

import AppHeader from "./AppHeader";
import Main from "./Main";
import AppFooter from "./AppFooter";
import theme from "./theme";

const history = createBrowserHistory();

const App = () => {
  return (
    <MuiThemeProvider theme={theme}>
      <React.Fragment>
        <CssBaseline />
        <div>
          <AppHeader />

          <Main />

          <AppFooter />
        </div>
      </React.Fragment>
    </MuiThemeProvider>
  );
};

const JazaApp = () => {
  return (
    <Provider store={store}>
      <Router history={history}>
        <App />
      </Router>
    </Provider>
  );
};

export default JazaApp;
